import { ref } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

import { COOKIE_SETTINGS } from "@/utils/cookies";

import type { SortDirection } from "@tanstack/vue-table";

export const useMemoDefaultParams = (
  key: string,
  {
    pageSize,
    sortDir,
    sortKey,
    filter,
  }: {
    pageSize: number;
    sortDir: SortDirection | "";
    sortKey: string;
    filter: string;
  },
) => {
  const cookies = useCookies();
  const paramsFromCookies = cookies.get(key) || {};

  const defaultParams = ref({
    pageSize,
    sortDir,
    sortKey,
    filter,
    ...paramsFromCookies,
  });

  const handleParamsChange = (newParams: {
    pageSize: number;
    sortDir: SortDirection | "";
    sortKey: string;
    filter: string;
  }) => {
    defaultParams.value = { ...defaultParams.value, ...newParams };
    cookies.set(key, defaultParams.value, COOKIE_SETTINGS);
  };

  return {
    defaultParams,
    handleParamsChange,
  };
};

export default {};
